import { useState } from "react";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Button, Card, Col, Dropdown, Input, Row } from "antd";
import {
  EllipsisOutlined,
  EditFilled,
  DeleteOutlined,
} from "@ant-design/icons";
import { debounce } from "lodash";
import CommonTable from "../../../common/CommonTable";
import EditTeam from "./EditTeam";
import DeleteTeam from "./DeleteTeam";
import { useTeamManagement } from "../hooks/useTeamManagement";
const { Search } = Input;

const TeamListing = () => {
  const [team, setTeam] = useState();
  const [isDelete, setDelete] = useState();
  const {
    teams,
    handleDelete,
    loading: isLoading,
    onFilterChange,
  } = useTeamManagement();
  const [searchParams] = useSearchParams();
  const page = searchParams.get("page");
  const loading = useSelector((state) => state.teamManagementReducer.loading);

  const columns = [
    {
      title: "Name",
      dataIndex: "teamName",
      key: "teamName",
      sorter: true,
    },
    {
      title: "Location",
      dataIndex: "location",
      key: "location",
      sorter: true,
    },
    {
      title: "Manager",
      dataIndex: "managerName",
      key: "managerName",
      sorter: true,
    },
    {
      title: "Description",
      dataIndex: "description",
      key: "description",
    },
    {
      title: "Actions",
      dataIndex: "id",
      render: (record, row) => {
        const items = [
          {
            key: "1",
            label: (
              <Row
                gutter={row?.active ? 12 : 24}
                className="heading14px"
                style={{ color: "#29292B" }}
                onClick={() => setTeam(row)}
              >
                <Col span={6}>
                  <EditFilled />
                </Col>
                <Col span={18}>Edit</Col>
              </Row>
            ),
          },
          {
            key: "2",
            label: (
              <Row
                gutter={row?.active ? 12 : 24}
                style={{ color: "#29292B" }}
                onClick={() => setDelete(row)}
              >
                <Col span={6}>
                  <DeleteOutlined className="heading14px text-error" />
                </Col>

                <Col span={18} className="heading14px text-error">
                  Delete
                </Col>
              </Row>
            ),
          },
        ].filter(Boolean);

        return (
          <Dropdown
            menu={{
              items,
            }}
            trigger={["click"]}
          >
            <Button type="text" icon={<EllipsisOutlined />} />
          </Dropdown>
        );
      },
    },
  ];

  const onSearch = debounce((event) => {
    onFilterChange("globalSearchTerm", event?.target?.value || undefined);
    onFilterChange("page", 1);
  }, 500);

  return (
    <Card
      title={
        <div className="d-flex align-items-center gap-20 justify-content-between">
          <span className="text-theme heading18px">Teams</span>
          <Search
            defaultValue={searchParams.get("globalSearchTerm")}
            allowClear
            onChange={onSearch}
            style={{ minWidth: 200, maxWidth: 300 }}
          />
        </div>
      }
      className="rounded-2xl shadow-md"
    >
      <CommonTable
        columns={columns}
        dataSource={teams?.content}
        loading={loading}
        showSorterTooltip={true}
        sortDirections={["ascend", "descend"]}
        pagination={{
          pageSize: 10,
          total: teams?.totalElements,
          defaultCurrent: 1,
          current: page || 1,
          onChange: (page, pageSize) => {
             onFilterChange("page", page);
          },
        }}
        onChange={(pagination, filters, sorter) => {
          onFilterChange(
              "sort",
              !!sorter?.field
                ? sorter?.order === "ascend"
                  ? sorter?.field + ",asc"
                  : sorter?.field + ",desc"
                : undefined
            );
        }}
      />
      <EditTeam team={team} isOpen={team} closeModal={() => setTeam()} />
      <DeleteTeam
        isOpen={isDelete}
        isLoading={isLoading}
        handleCancel={() => setDelete()}
        handleDelete={handleDelete}
      />
    </Card>
  );
};

export default TeamListing;
